import { trackMenuNavigation } from '../menuAnalytics';
import {
  foundayoPromoCopy,
  getFoundayoPdpUrl,
  getRedesignAssetRoot,
} from '../foundayoMenuPromo';

type MainProps = {
  language: string;
  weightLossUrl?: string;
};

export function FoundayoMenuPromoMain({ language, weightLossUrl }: MainProps) {
  const href = getFoundayoPdpUrl({ weightLossUrl });
  const redesignRoot = getRedesignAssetRoot();
  const copy = foundayoPromoCopy(language);

  return (
    <div id="foundayo-menu-promo-main" className="px-3 md:px-4 pt-4">
      <a
        href={href}
        className="foundayo-menu-promo foundayo-menu-promo--main relative block min-h-[156px] w-full overflow-hidden rounded-[20px] bg-[#f5f6f7] no-underline md:min-h-[137px]"
        onClick={() => {
          trackMenuNavigation({
            category: 'weight_loss',
            button_label: 'foundayo_menu_promo_main',
            carousel: 'no',
            sub_category: '',
            link: href,
          });
        }}
      >
        <img
          src={`${redesignRoot}/weight_loss/foundayo_menu_promo_main/foundayo_menu_promo_main.png`}
          alt=""
          className="pointer-events-none absolute inset-0 z-0 h-full w-full object-cover object-center"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        {/* Soft left veil only — full-bleed pack stays sharp; HTML is readable over bake. */}
        <div
          className="pointer-events-none absolute inset-y-0 left-0 z-[1] w-[62%]"
          style={{
            background:
              'linear-gradient(90deg, rgba(255, 111, 0, 0.88) 0%, rgba(255, 111, 0, 0.72) 55%, rgba(255, 111, 0, 0) 100%)',
          }}
          aria-hidden="true"
        />
        <div className="relative z-10 flex min-h-[156px] max-w-[58%] flex-col justify-center gap-1.5 py-4 pl-[18px] pr-14 md:min-h-[137px] md:gap-[6px] md:py-3 md:pl-[21px] md:pr-16">
          <span className="inline-flex self-start items-center rounded-full border border-white/30 bg-white/20 px-3 py-1 font-poppins text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-white whitespace-nowrap md:px-[15px] md:text-[12px] md:tracking-[0.18em]">
            {copy.mainBadge}
          </span>
          <span className="font-poppins text-[22px] font-medium leading-[1.2] text-white md:text-[26px] md:leading-snug">
            {copy.mainTitle}
          </span>
          <span className="font-poppins text-[13px] font-normal leading-[1.25] text-white/80 md:text-[14px] md:leading-snug">
            {copy.mainSubtitle}
          </span>
        </div>
        <span
          className="absolute bottom-3 right-5 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-white bg-[#f5f6f7] md:bottom-[11px] md:right-[28px] md:h-[46px] md:w-[46px]"
          aria-hidden="true"
        >
          <img src="/img_v4/svg/icons/from_figma/arrow-icon.svg" alt="" className="h-4 w-4 md:h-5 md:w-5" />
        </span>
      </a>
    </div>
  );
}

type WlProps = {
  language: string;
  categoryUrl?: string;
  trackingCategory: string;
};

export function FoundayoMenuPromoWl({ language, categoryUrl, trackingCategory }: WlProps) {
  const href = getFoundayoPdpUrl({ categoryUrl });
  const redesignRoot = getRedesignAssetRoot();
  const copy = foundayoPromoCopy(language);

  return (
    <div id="foundayo-menu-promo-wl" className="mx-3 mt-2">
      <a
        href={href}
        className="foundayo-menu-promo foundayo-menu-promo--wl relative block h-[176px] w-full overflow-hidden rounded-[20px] bg-[#f5f6f7] no-underline md:h-[137px]"
        onClick={(e) => {
          const link = (e.currentTarget as HTMLAnchorElement).href;
          trackMenuNavigation({
            category: trackingCategory,
            button_label: 'foundayo_menu_promo_wl',
            carousel: 'no',
            sub_category: '',
            link: link.replace(window.location.origin, '') || link,
          });
        }}
      >
        <img
          src={`${redesignRoot}/weight_loss/foundayo_menu_promo_wl/foundayo_menu_promo_wl.png`}
          alt=""
          className="pointer-events-none absolute inset-0 z-0 h-full w-full object-cover object-center"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
        <div className="relative z-10 flex h-full max-w-[70%] flex-col gap-[8px] pl-[21px] pr-4 pt-[24px]">
          <span
            className="inline-flex self-start items-center rounded-full px-[16px] py-[8px] font-poppins text-[14px] font-medium uppercase leading-none tracking-[0.08em] text-white whitespace-nowrap shadow-[0_10px_8px_rgba(235,83,1,0.35)] md:text-[12px]"
            style={{ background: 'linear-gradient(95.85deg, #ffa237 18.5%, #ff6e1f 117.7%)' }}
          >
            {copy.wlBadge}
          </span>
        </div>
        <span
          className="absolute bottom-[27px] left-[25px] z-10 flex h-[46px] w-[46px] items-center justify-center rounded-full border border-white bg-[#f5f6f7] md:bottom-[11px] md:left-[21px]"
          aria-hidden="true"
        >
          <img src="/img_v4/svg/icons/from_figma/arrow-icon.svg" alt="" className="h-5 w-5" />
        </span>
      </a>
    </div>
  );
}
